import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctInteger24, FctTimestamp, FctValue, FctValue24 } from '../../../../Fct/generics';
import { getAllCurrencies } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { NONFUNGIBLE_POSITION_MANAGER_ADDRESSES } from '../helpers/constants';
// P = (sqrtPriceX96 / 2^96) ^ 2
// Price of ETH = 1 / P x 1e12
/*
  P = 1.0001 ** tick
  P = (sqrtPriceX96 / 2e96) ** 2

  L = sqrt((amount0 * amount1))

*/
export var Mint = createPlugin({
    protocol: 'UNISWAP_V3',
    type: 'ACTION',
    method: 'mint',
    supportedContracts: NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    params_tuple: {
                        token0: new FctAddress({ destination: 'erc20', options: getAllCurrencies({ chainId: chainId }) }),
                        token1: new FctAddress({ destination: 'erc20', options: getAllCurrencies({ chainId: chainId }) }),
                        fee: new FctValue24({}),
                        tickLower: new FctInteger24({}),
                        tickUpper: new FctInteger24({}),
                        amount0Desired: new FctValue({ destination: 'wei_amount' }),
                        amount1Desired: new FctValue({ destination: 'wei_amount' }),
                        amount0Min: new FctValue({ destination: 'wei_amount' }),
                        amount1Min: new FctValue({ destination: 'wei_amount' }),
                        recipient: new FctAddress({}),
                        deadline: new FctTimestamp({}),
                    },
                },
            },
            output: {
                tokenId: new FctValue({ innerIndex: 0, destination: 'eip712_tokenId' }),
                liquidity: new FctValue({ innerIndex: 1 }),
                amount0: new FctValue({ innerIndex: 2, destination: 'wei_amount' }),
                amount1: new FctValue({ innerIndex: 3, destination: 'wei_amount' }),
            },
        });
    },
    initParams: {
        methodParams: {
            params_tuple: {
                deadline: { type: 'global', id: 'blockTimestamp' },
            },
        },
    },
    requiredApprovals: function (params) {
        var token0 = params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].token0.value;
        var token1 = params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].token1.value;
        return [
            {
                to: token0,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amount0Desired.value },
                method: 'approve',
                protocol: 'ERC20',
            },
            {
                to: token1,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amount1Desired.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
